
import chMessages from '../locales/fr-FR';

const FrLang = {
    messages: {
        ...chMessages
    },
    locale: 'fr-FR',
  
};
export default FrLang;